import { KeyingConfig } from "@urql/exchange-graphcache";

export const keyingConfig: KeyingConfig = {
  // Utility types without id
  PageInfo: () => null,
  Link: () => null,
  RawImage: () => null,
  Error: () => null,
  StringWrapper: () => null,
  Label: (obj) => String(obj.id),
  UserOnboardingState: () => null,
  WorkspaceOnboardingState: () => null,
  ProjectMetadata: () => null,
  BillingInfo: () => null,
  PayoutAccount: () => null,
  PayoutCountry: () => null,
  UserDismissedUI: () => null,
  UserProfileInfo: () => null,
  UserDismissedHomepageUI: () => null,
  UserDismissedStylesUI: () => null,
  TranslationLanguagesResult: () => null,
  FileThumbnails: () => null,
  FileThumbnail: () => null,
  InferenceDefaults: () => null,
  GenerationPriceEstimate: () => null,
  TrainingConfig: () => null,
  BaseModelInfo: () => null,
  Ratings: () => null,
  BlueprintCastingRule: () => null,
  BlueprintCastingRuleTransformer: () => null,
  BlueprintConnectedValuesSource: () => null,
  BlueprintEstimationResult: () => null,
  BlueprintInputParameter: () => null,
  BlueprintIOType: () => null,
  BlueprintNodeExecutionEstimate: () => null,
  BlueprintNodeKind: () => null,
  BlueprintNodeInputPort: () => null,
  BlueprintNodeOutputPort: () => null,
  BlueprintNodeOutputPortCount: () => null,
  BlueprintNodeParameterValue: () => null,
  BlueprintNodePortInput: () => null,
  BlueprintNodePortReference: () => null,
  BlueprintNodePortValueSource: () => null,
  BlueprintObjectValidationError: () => null,
  BlueprintOutputParameter: () => null,
  BlueprintParameterReference: () => null,
  BlueprintParameterValue: () => null,
  BlueprintTargetSlot: () => null,
  BlueprintSystemConfig: () => null,
  BlueprintValidationError: () => null,
  BlueprintValidationResult: () => null,
  CanvasViewport: () => null,
  SessionCanvasState: () => null,
  SessionFormState: () => null,
  SessionBlueprintFormState: () => null,
  SessionBlueprintParameters: () => null,
  WorkspaceUsage: () => null,
  ActionPricing: () => null,
  InferencePricing: () => null,
  ReferenceSetAutoTrainingCostEstimate: () => null,
  ReferenceSetModelCompatibility: () => null,
  AutoTrainingRunCostEstimate: () => null,
  WorkspaceDefaultStyle: () => null,
  WorkspaceMemberUiState: () => null,
  Shortcut: () => null,
  SavedLibraryFilter: () => null,
  WorkspaceUsageEntitlement: () => null,
  WorkspaceUsageForChart: () => null,
  WorkspaceUsageHistory: () => null,
  WorkspaceEntitlementHistory: () => null,
  WorkspaceEntitlementHistoryBurndown: () => null,
  WorkspaceEntitlementHistoryGrantUsage: () => null,
  WorkspaceEntitlementHistoryPeriod: () => null,
  UserUsageLimitInfo: () => null,
  HierarchyUsage: () => null,
  HierarchyWorkspaceUsage: () => null,

  // Library object types with id
  ReferenceSet: (data) => String(data.id),
  ReferenceSetContribution: () => null,
  ReferenceSetLora: () => null,
  CreativeUnitTransfer: (data) => String(data.id),

  // Achievement types without id (AchievementAward/Achievement carry ids and normalize)
  AchievementTier: () => null,
  WorkspaceAchievements: () => null,
  ClaimedAchievementRewards: () => null,

  // Result wrapper types without id
  LibraryObjectsResult: () => null,
  InferencesResult: () => null,
  StyleAutoPopulationResult: () => null,
  TextualValues: () => null,
  ChildAllocationConfig: () => null,
  UpdateCanvasObjectsResult: () => null,
  DeleteCanvasObjectsResult: () => null,
  RestoreCanvasObjectsResult: () => null,
  SessionCanvasObjectEvent: () => null,

  // Connection types without id
  PersonalAccessTokensConnection: () => null,
  WorkspaceIntegrationsConnection: () => null,
  WorkspaceMembershipsConnection: () => null,
  WorkspaceLibraryObjectConnection: () => null,
  WorkspaceAssetsConnection: () => null,
  WorkspaceDirectoriesConnection: () => null,
  WorkspaceFilesConnection: () => null,
  WorkspaceStylesConnection: () => null,
  InferencesConnection: () => null,
  StyleFinetunesConnection: () => null,
  StyleTrainingRunsConnection: () => null,
  StylesConnection: () => null,
  FilesConnection: () => null,
  SessionObjectConnection: () => null,
  BlueprintRunsConnection: () => null,
  SessionsConnection: () => null,
  SessionTemplateConnection: () => null,
  EventsConnection: () => null,
  BlueprintsRelayConnection: () => null,
  SearchResultsConnection: () => null,
  SearchFilesConnection: () => null,
  SearchReferenceSetsConnection: () => null,
  SearchBlueprintsConnection: () => null,
  SearchBaseModelsConnection: () => null,
  SearchProjectsConnection: () => null,
  SearchSessionsConnection: () => null,
  SearchFacet: () => null,
  SearchFacetValue: () => null,
  MiroBoardsConnection: () => null,

  // Edge types without id
  PersonalAccessTokenEdge: () => null,
  WorkspaceIntegrationEdge: () => null,
  WorkspaceMembershipEdge: () => null,
  WorkspaceLibraryObjectEdge: () => null,
  WorkspaceAssetEdge: () => null,
  WorkspaceDirectoryEdge: () => null,
  WorkspaceFileEdge: () => null,
  WorkspaceStyleEdge: () => null,
  InferenceEdge: () => null,
  StyleFinetuneEdge: () => null,
  StyleTrainingRunEdge: () => null,
  StyleEdge: () => null,
  FileEdge: () => null,
  SessionObjectEdge: () => null,
  BlueprintRunEdge: () => null,
  SessionEdge: () => null,
  SessionTemplateEdge: () => null,
  EventEdge: () => null,
  BlueprintRelayEdge: () => null,
  BlueprintEdge: () => null,
  SearchResultEdge: () => null,
  SearchFileEdge: () => null,
  SearchReferenceSetEdge: () => null,
  SearchBlueprintEdge: () => null,
  SearchBaseModelEdge: () => null,
  SearchProjectEdge: () => null,
  SearchSessionEdge: () => null,
  MiroBoardEdge: () => null,
};
